import React from "react";
import styled from "styled-components";
import TechAccordion from "./tech-accordion";

const TopBanner = styled.div`
  background-color: #f8d210;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  margin-bottom: 30px;
  width: 100%;
  height: 220px;
  gap: 8px;
  border-radius: 4px;
  @media only screen and (max-width: 992px) {
    margin-top: 70px;
    border-radius: 0;
  }
`;

const FaqContainer = styled.div`
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 1px 3px 20px rgba(1, 1, 1, 0.07);
  border-radius: 4px;
  margin: 50px auto;
  padding: 10px;
`;

const TechFaq = ({ course }) => {
  // Ensure course is always an array for TechAccordion
  const faqData = Array.isArray(course) ? course : course ? [course] : [];
  return (
    <div className="bg-gray w-full">
      <div className="max-w-[1200px] m-auto">
        <TopBanner>
          <h1 className="font-bold text-2xl sm:text-4xl text-center">
            Tech Experience <br />Frequently Asked Questions
          </h1>
        </TopBanner>
        <div className="px-4">
          <FaqContainer>
            <TechAccordion faq={faqData} />
          </FaqContainer>
        </div>
      
      </div>
    </div>
  );
};

export default TechFaq;
